module.exports = __webpack_public_path__ + "media/images/riders/EMILIE_SIEGENTHALER-391e70024d4685667a07e3cf565fb499.png";